import { HttpErrorResponse } from '@angular/common/http';

// Only the status is evaluated: every rejected code yields the same 401, so reading the body
// could only ever leak which addresses or codes exist.
export function otpVerifyErrorKey(error: HttpErrorResponse, rateLimitedKey: string): string {
  if (error.status === 429) {
    return rateLimitedKey;
  }
  if (error.status >= 400 && error.status < 500) {
    return 'login.otp.errorInvalidCode';
  }
  return 'login.otp.errorUnavailable';
}
